<template>
	<v-dialog v-model="dialog" max-width="400px">
		<v-card>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">図面検索</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="dialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<v-card-text class="pa-2">
				<v-text-field
					label="図面番号"
					dense
					outlined
					class="mt-2"
					hint="図面番号を入力してください"
					v-model="searchWord"
				/>
				<v-select
					v-model="selected"
					:items="[
						{ name: '全て', value: 'all' },
						{ name: '存在している', value: 'not_deleted' },
						{ name: '削除済', value: 'deleted' },
					]"
					item-text="name"
					item-value="value"
					label="対象"
					class="mt-2"
					outlined
					dense
				/>
				<v-btn class="mt-2" :disabled="!searchWord" color="primary" @click="searchDrawings()"
					>検索</v-btn
				>
			</v-card-text>
			<v-spacer />
			<v-btn icon dark @click="dialog = false" color="white">
				<v-icon>mdi-close</v-icon>
			</v-btn>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import rules from "../../../helper/rules"
import common from "../../../helper/common"

export default {
	props: {},
	components: {},
	data() {
		return {
			dialog: false,
			searchWord: "",
			selected: null,
		}
	},
	methods: {
		openDialog() {
			this.dialog = true
		},
		searchDrawings() {
			this.$emit("searchDrawing", this.searchWord, this.selected)
			this.dialog = false
		},
	},
	watch: {},
	computed: {},
}
</script>
<style scoped>
.selected-matter-card {
	max-width: 320px;
}
</style>
